import { companyInfo, heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20flowing%20deep%20teal%20and%20warm%20amber%20gradient%20waves%2C%20smooth%20geometric%20curved%20lines%20and%20subtle%20grid%20and%20interconnected%20supply%20chain%20nodes%2C%20dark%20elegant%20background%2C%20smooth%20modern%20minimal%20industrial%20corporate%20aesthetic%2C%20soft%20glow%2C%20premium%20clean%20modern%20abstract%20composition%2C%20high%20detail&width=1920&height=1080&seq=junxinlan-hero-01&orientation=landscape&nocache=true"
          alt="武汉俊鑫岚科技有限公司 工业物资与建材供应 背景"
          title="武汉俊鑫岚科技 综合物资供应"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/55 to-primary-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-10 pt-28 pb-20 md:pt-32 md:pb-24">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-accent-300 text-xs md:text-sm tracking-wide">
            <i className="ri-flashlight-fill"></i>
            综合商贸 · 工业物资与建材一站式供应
          </span>

          <h1 className="mt-6 font-heading font-bold text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight">
            {companyInfo.slogan}
          </h1>

          <p className="mt-6 max-w-2xl text-sm md:text-lg text-background-200 leading-relaxed">
            {companyInfo.name}专注为企业与工程客户提供建筑建材、机械电气、金属材料、电子配件、五金耗材等多品类物资供应，
            以稳定的货源、可靠的品质与高效的配送，助力客户高效运转。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
            <a
              href="#contact"
              className="px-7 py-3.5 rounded-md bg-accent-500 text-accent-950 font-medium text-sm md:text-base hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              获取报价
            </a>
            <a
              href="#services"
              className="px-7 py-3.5 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              查看主营产品
            </a>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="px-4 py-5 md:px-6 md:py-6 rounded-lg bg-background-50/10 border border-background-50/15 backdrop-blur-sm"
            >
              <div className="font-heading font-bold text-2xl md:text-3xl text-accent-400">{stat.value}</div>
              <div className="mt-2 text-xs md:text-sm text-background-200">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#about"
        className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
        aria-label="向下滚动"
      >
        <span className="text-xs tracking-widest">了解更多</span>
        <i className="ri-arrow-down-line text-xl animate-bounce"></i>
      </a>
    </section>
  );
}